import { useMutation } from '@tanstack/react-query';

import {
  useRequest,
  type MutationFunction,
  type MutationFunctionContext,
  type RequestQueryObject,
} from '@frontend/api';

import type { Rule, RuleDetailsError } from './types';

export type CreateRuleRequestBody = Omit<Rule, 'uuid'>;

const useCreateRuleKey = ['rules', 'create'] as const;
export const getUseCreateRuleKey = () => useCreateRuleKey;

/**
 * Mutation function for creating a new rule.
 */
export const useCreateRule: MutationFunction<
  Rule,
  CreateRuleRequestBody,
  [],
  RequestQueryObject,
  RuleDetailsError
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation<
    Rule,
    RuleDetailsError,
    CreateRuleRequestBody,
    MutationFunctionContext<Rule>
  >({
    mutationFn: (body) =>
      request<Rule>('/rules', {
        init: {
          method: 'POST',
          body,
        },
      }),
    ...queryOptions,
    mutationKey: getUseCreateRuleKey(),
  });
};
